import { createAsyncTypes } from 'utils/ActionCreator'

export const COMPANIES_DATA_REQUEST_ASYNC = createAsyncTypes(
  'COMPANIES_DATA_REQUEST',
  'Settings/GroupSettings/Assign'
)
export const ASSIGN_REQUEST_ASYNC = createAsyncTypes(
  'ASSIGN_REQUEST',
  'Settings/GroupSettings/Assign'
)

export const FILTERS_CHANGE = 'Settings/GroupSettings/Assign/FILTERS_CHANGE'
export const FILTERS_CLEAR = 'Settings/GroupSettings/Assign/FILTERS_CLEAR'
export const FILTERS_SUBMIT = 'Settings/GroupSettings/Assign/FILTERS_SUBMIT'
export const ASSIGNED_FILTER_CHANGE = 'Settings/GroupSettings/Assign/ASSIGNED_FILTER_CHANGE'

export const SORT_PROPERTY_CHANGE = 'Settings/GroupSettings/Assign/SORT_PROPERTY_CHANGE'

export const PAGINATE_CHANGE = 'Settings/GroupSettings/Assign/PAGINATE_CHANGE'

export const SEARCH_CHANGE = 'Settings/GroupSettings/Assign/SEARCH_CHANGE'
export const SEARCH_RESET = 'Settings/GroupSettings/Assign/SEARCH_RESET'

export const SELECT_TOGGLE = 'Settings/GroupSettings/Assign/SELECT_TOGGLE'
export const ACTIVATE_SELECT_ALL = 'Settings/GroupSettings/Assign/ACTIVATE_SELECT_ALL'

export const EMAIL_INTEGRATION_FILTER_OPTIONS = [
  { value: 3, label: 'Office 365' },
  { value: 2, label: 'Google Workspace' },
  { value: 1, label: 'Microsoft Exchange' },
  { value: 0, label: 'No integration' },
]

export const DEFAULT_ASSIGNED_FILTER = 2

export const FILTERS_LIST = [
  {
    label: 'Email Integration',
    id: 'EmailIntegration',
    filterName: 'emailIntegrationFilter',
    options: EMAIL_INTEGRATION_FILTER_OPTIONS,
    staticOptions: true,
  },
  {
    label: 'Group Settings',
    id: 'GroupSettings',
    filterName: 'groupSettingsFilter',
    options: 'groupSettingsFilterOptions',
  },
]

export const PER_PAGE = 50
